import { SessionProvider } from '#client/contexts/SessionContext.jsx';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppProvider } from '@shopify/polaris';
import { ToastProvider } from '#client/components/common/Toast/ToastContext.jsx';
import '@shopify/polaris/build/esm/styles.css';
import AppRouter from './AppRouter';
import './App.css';
import enTranslations from '@shopify/polaris/locales/en.json';
import { queryClient } from '#client/utils/queryClient.js';

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <SessionProvider>
                <AppProvider i18n={enTranslations}>
                    <ToastProvider>
                        <AppRouter />
                    </ToastProvider>
                </AppProvider>
            </SessionProvider>
            {import.meta.env.VITE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    );
}

export default App;
